<template>
  <header class="header header-container" id="main-header">

    <md-toolbar :class="{'overlay-toolbar':overlay, 'normal-toolbar': !overlay}">
        <div class="md-toolbar-section-start">
          <b-col style="max-width:200px;">
            <div class="header-logo-holder" :class="{'white':overlay}" @click="navigateHome"></div>
          </b-col>
          <b-col style="max-width:200px;">
            <md-button class="md-fab md-mini md-primary" :class="{'moow-fab-mini':overlay}" @click="toggleTutorial()">
              <md-icon>help_outline</md-icon>
              <md-tooltip md-direction="bottom">What's Moowle?</md-tooltip>
            </md-button>
          </b-col>
          <!-- <div v-if="showAddressSearch" class="header-navbar-search">
            <adr-search-bar
              :onPlaceSelected="selectPlace"
              keywordPlaceholder="City"
              :onError="searchError"
              searchType="(cities)">
            </adr-search-bar>
          </div> -->
        </div>

        <div class="md-toolbar-section-end">
          <b-navbar toggleable="lg">
            <md-button class="md-icon-button" @click="toggleMenu" v-if="!menuVisible && narrowWidth">
              <md-icon>menu</md-icon>
            </md-button>
            <b-collapse is-nav id="nav_collapse" v-else>
              <b-navbar-nav class="ml-auto mt-auto mo-navbar-dropdown">
                <b-navbar-nav>
                  <b-nav-item :to="{name:'listingsearch'}" :class="{'white-text':overlay}">MARKET</b-nav-item>
                  <b-nav-item :to="{name:'landlord'}" v-if="!loggedIn" :class="{'white-text':overlay}">LANDLORD</b-nav-item>
                  <b-nav-item :to="{name:'register'}" v-if="!loggedIn" :class="{'white-text':overlay}">SIGN UP</b-nav-item>
                  <b-nav-item :to="{name:'login'}" v-if="!loggedIn" :class="{'white-text':overlay}">LOG IN</b-nav-item>
                  <b-nav-item :to="{name:'dashboard'}" v-if="loggedIn" :class="{'white-text':overlay}">PROPERTIES</b-nav-item>
                  <b-nav-item :to="{name:'stays'}" v-if="loggedIn" :class="{'white-text':overlay}">STAYS</b-nav-item>
                  <b-nav-item :to="{name:'bookings'}" v-if="loggedIn" :class="{'white-text':overlay}">BOOKINGS</b-nav-item>
                  <b-nav-item :to="{name:'chat'}" v-if="loggedIn" :class="{'white-text':overlay}">
                    CHAT <div v-if="showUnreadMsgBadge" class="mo-badge"></div>
                  </b-nav-item>
                </b-navbar-nav>
                <b-nav-item-dropdown right style="margin-left:30px;" v-if="loggedIn">
                  <template slot="button-content">
                    <md-avatar class="md-medium cast-shadow">
                      <img :src="imageSource" alt="A">
                    </md-avatar>
                  </template>
                  <b-dropdown-item v-if="loadingUser" style="color:#ec8080;">loading...</b-dropdown-item>
                  <b-dropdown-item :to="{name:'settings'}" v-else-if="loggedIn && !userIsVerified" style="color:#ec8080;">Verify account</b-dropdown-item>
                  <b-dropdown-item :to="{name:'settings'}" v-if="loggedIn && !loadingUser">Edit Profile</b-dropdown-item>
                  <b-dropdown-item :to="{name:'account'}" v-if="loggedIn && !loadingUser">Landlord settings</b-dropdown-item>
                  <!-- <b-dropdown-item v-if="loggedIn && !loadingUser">
                    <md-field>
          <label for="movie">Switch Account</label>
          <md-select v-model="selectedAccount" name="account" id="account">
            <md-option :value="account.accoundId">Fight Club</md-option>
          </md-select>
        </md-field>
                  </b-dropdown-item> -->
                  <b-dropdown-item @click="logOut" v-if="loggedIn">Log Out</b-dropdown-item>
                </b-nav-item-dropdown>
              </b-navbar-nav>
            </b-collapse>
          </b-navbar>
        </div>
    </md-toolbar>
    <!--  HIDDEN DRAWER -->
    <md-drawer :md-active.sync="menuVisible" md-right=true v-if="menuVisible" md-swipeable>
      <md-toolbar class="md-transparent" md-elevation="0">
        <div class="header-logo-holder"></div>

        <div class="md-toolbar-section-end">
          <md-button class="md-icon-button md-dense" @click="toggleMenu">
            <md-icon>keyboard_arrow_left</md-icon>
          </md-button>
        </div>
      </md-toolbar>
      <md-list class="mt-2">
       <md-list-item to="/market">
         <md-icon>explore</md-icon>
         <span class="md-list-item-text">Marketplace</span>
       </md-list-item>

       <md-list-item to="/dashboard" v-if="loggedIn">
         <md-icon>description</md-icon>
         <span class="md-list-item-text">Properties</span>
       </md-list-item>

       <md-list-item to="/stays" v-if="loggedIn">
         <md-icon>place</md-icon>
         <span class="md-list-item-text">Stays</span>
       </md-list-item>

       <md-list-item to="/deals" v-if="loggedIn">
         <md-icon>bookmarks</md-icon>
         <span class="md-list-item-text">Deals</span>
       </md-list-item>

       <md-list-item md-expand v-if="loggedIn">
          <md-icon>account_circle</md-icon>
          <span class="md-list-item-text">Account</span>

          <md-list slot="md-expand">
            <md-list-item to="/settings">
              <md-icon>settings</md-icon>
              <span class="md-list-item-text">Edit Profile</span>
            </md-list-item>

            <md-list-item to="/account" >
              <md-icon>perm_data_setting</md-icon>
              <span class="md-list-item-text">Landlord Settings</span>
            </md-list-item>

            <md-list-item to="/market" @click="logOut">
              <md-icon>power_settings_new</md-icon>
              <span class="md-list-item-text">Log Out</span>
            </md-list-item>
          </md-list>
        </md-list-item>

        <md-list-item to="/login" v-if="!loggedIn">
          <md-icon>power_settings_new</md-icon>
          <span class="md-list-item-text">Log In</span>
        </md-list-item>

        <md-list-item to="/register" v-if="!loggedIn">
          <md-icon>account_circle</md-icon>
          <span class="md-list-item-text">Sign Up</span>
        </md-list-item>
     </md-list>
   </md-drawer>

  <md-dialog :md-active.sync="showTutorial" class="moow-vert-scrollbar">
    <md-dialog-title class="moow-header-2">What is Moowle?</md-dialog-title>
    <md-content style="padding:1em;">
      <p class="moow-info-txt">For landlord, Moowle allows You to manage your property, listings, revenues, contracts and tenants all in one place.</p>
      <p class="moow-info-txt">For tenants, you can contact landlords directly via built in chat, get custom deals and book on-demand. Did we mention automatic contracts and rent payments?</p>
    

    <md-tabs md-dynamic-height>
      <md-tab md-label="For Landlord">
        <ol class="moow-info-txt">
          <li> Register for free</li>
          <li> Manage Property - edit listing here, changes go to all connected portals automatically.</li>
          <li> Real-time analytics & conversion.</li>
          <li> Booking Requests - chat and offer directly to a vetted tenant using built in chat and other tools.</li>
          <li> Manage Bookings - bookings, contracts, rent, calendar and other details all here in one place.</li>
          <li> Receive Rent - receivce, don't collect as payments are automated!</li>
        </ol>
      </md-tab>

      <md-tab md-label="For Tenant">
        <ol class="moow-info-txt">
          <li> Register for free</li>
          <li> Shop for Listing - you can find the same listings here as well as on on all the major portals.</li>
          <li> Connect to Landlord - chat and get custom offers from the owner directly.</li>
          <li> Book the Place - book the stay right in the same chat with the sweet custom deal.</li>
          <li> Manage Your Stay - pay for rent, enjoy automatic contracts and other information.</li>
          <li> Stay in Touch - your landlord is always a click away.</li>
        </ol>
      </md-tab>
    </md-tabs>

      <md-divider class="moow-divider"></md-divider>

    <b-row>
      <b-col>
        <p>+372 5366 6903 • info@moowle.com</p>
        <p>EDMI Group OÜ • Pärnu mnt 148, Tallinn</p>
      </b-col>
            <b-col>
        <p class="moow-info-txt"><a href="https://moowle.com/terms-of-use/" target="_blank">Terms of use</a></p>
        <p class="moow-info-txt"><a href="https://moowle.com/privacy-policy/" target="_blank">Privacy Policy</a></p>
      </b-col>
    </b-row>
</md-content>
    <md-dialog-actions>
      <md-button
        class="md-primary play-cta-button-flat grey"
        @click="showTutorial = false">Got it</md-button>
      <md-button
        class="md-raised md-primary play-cta-button navy"
        style="text-decoration:none"
        @click="openContactUsForm">Contact Sales</md-button>
    </md-dialog-actions>
  </md-dialog>

    <md-dialog :md-active.sync="showContactForm">
      <contact-form
        @closeForm="closeContactUsForm">
      </contact-form>
    </md-dialog>



    <md-snackbar :md-active.sync="showSnackbar" md-persistent>
      <span>{{snackbarMessage}}</span>
    </md-snackbar>


  </header>
</template>

<script>
  import ContactUsForm from '../components/dialogs/ContactUsForm'
  import AddressSearchBar from '../components/adrSearchBar.vue';
  import {
    getUserUid
  } from "../functions.js"
  export default {
    props:{
      showAddressSearch:{
        type:Boolean,
        default:true
      },
      overlay:{
        type: Boolean,
        default: false
      }
    },
    components: {
      'contact-form':ContactUsForm,
      'adr-search-bar': AddressSearchBar
    },
    data() {
      return {
        imageSource: '../static/avatar.png',
        narrowWidth: false,
        showNavigation: false,
        menuVisible:false,
        showTutorial:false,
        showContactForm:false,
        showSnackbar:false,
        snackbarMessage: "",
      };
    },
    computed:{
      loggedIn(){
        return this.$store.getters.isUserLoggedIn
      },
      tenantFlow() {
        return require("../assets/tenant-flow.png");
      },
      landlordFlow() {
        return require("../assets/landlord-flow.png");
      },
      showUnreadMsgBadge(){
        return this.$store.getters.showUnreadMsgBadge
      },
      userIsVerified(){
        return this.$store.getters.isUserVerified
      },
      loadingUser(){
        return this.$store.getters.loadingUser
      }
    },
    created(){
      window.addEventListener('resize', this.handleWindowResize)
      this.handleWindowResize();
    },
    methods: {
      openContactUsForm(){
        this.showContactForm=true
      },
      closeContactUsForm(isSuccess){
        this.showContactForm=false
        if(isSuccess) this.notifyUser("Thank You. We will be in touch promptly")
        else this.notifyUser("Something is not right, contact support@moowle.com")
      },
      notifyUser(msg){
        this.snackbarMessage = msg
        this.showSnackbar =  true
      },
      toggleTutorial(){
        this.showTutorial=true
      },
      toggleMenu(){
        this.menuVisible = !this.menuVisible
      },
      handleWindowResize(){
        this.narrowWidth = window.innerWidth <= 1100
      },
      searchError(error){
        this.$notify({
          title: "Something is not right",
          message: "Search is not working"
        })
      },
      selectPlace(googPrediction){
        var selectedPlace = googPrediction.description
        var placeId = googPrediction.place_id
        var filterMuni = ''
        try{
          var filterMuni = googPrediction.structured_formatting.main_text
        }catch(err){}
        this.$router.push({
            name: 'listingsearch',
            query: { autoq: 'true', muni: filterMuni }
        });
      },
      navigateHome(){
        this.$router.push({
          name: 'listingsearch'
        })
      },
      logOut(){
        this.$store.dispatch("logout");
      }
    }
  };

</script>
<style scoped>
  @import '../assets/styles/global.css';

  .overlay-toolbar{
     position: absolute;
     background-color: transparent;
     width: 100%;
     box-shadow: none;
  }

  .normal-toolbar{
    background-color: white;
    box-shadow: 0 0px 4px -1px rgba(0,0,0,.2), 0 0px 5px 0 rgba(0,0,0,.14), 0 1px 10px 0 rgba(0,0,0,.12);
  }
  

  .white-text a{
    color: white !important;
  }

  .mo-navbar-dropdown a{
    text-decoration: none;
  }


  .header-navbar-logo{
    margin-right: 2em;
  }

  .header-navbar-search{
    border: 1.2px solid #e2dede;
    border-radius: 20px;
    padding-right: 5px;
    padding-left: 5px;
    margin-left:2em;
  }

  .active {
    border-bottom: 2px solid #1f8efa;
    color: black !important;
  }

  #nav_collapse {
    line-height: 45px;
  }

  .dropdown-item a{
    text-decoration: none;
  }

  .dropdown-item {
    outline: none;
  }

  /*  from infinity to max 600 and then this kicks in*/
  @media (max-width: 600px) {
    .header-navbar-search{
      display: none;
    }
  }


</style>



// WEBPACK FOOTER //
// src/components/Header.vue